"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenDepositWhenLowBalance = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var pay_api_1 = require("@l2p/pay-api");
var date_fns_1 = require("date-fns");
var Lockr = __importStar(require("lockr"));
var react_1 = require("react");
var transactions_1 = require("../transactions");
var user_1 = require("../user");
var LOW_BALANCE_NOTIFICATION = 'lowBalanceNotification';
var frequencyNotification = 24;
var useOpenDepositWhenLowBalance = function () {
    var _a, _b, _c;
    var isAuth = (0, user_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var data = (0, transactions_1.useTransactions)(pay_api_1.TransactionTypeEnum.Deposit).data;
    var acceptedTransactions = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.transaction) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.filter(function (t) { return t.status === pay_api_1.TransactionStatusEnum.Accepted; });
    return (0, react_1.useCallback)(function (data) {
        if (!isAuth)
            return;
        if (!(data === null || data === void 0 ? void 0 : data.totalAmount) || !(data === null || data === void 0 ? void 0 : data.currency))
            return;
        if ((acceptedTransactions === null || acceptedTransactions === void 0 ? void 0 : acceptedTransactions.length) || 0 <= 0)
            return;
        var currentBalance = parseFloat(data.totalAmount);
        if ((apps_shared_1.triggerBalanceByCurrency === null || apps_shared_1.triggerBalanceByCurrency === void 0 ? void 0 : apps_shared_1.triggerBalanceByCurrency[data.currency]) <= currentBalance)
            return;
        var notificationDate = Lockr.get(LOW_BALANCE_NOTIFICATION);
        if (notificationDate) {
            var isNotificationCanBeShow = (0, date_fns_1.differenceInHours)(new Date(), new Date(notificationDate)) >=
                frequencyNotification;
            if (!isNotificationCanBeShow)
                return;
        }
        if (typeof window !== 'undefined')
            Lockr.set(LOW_BALANCE_NOTIFICATION, new Date());
        openDeposit();
    }, [isAuth, openDeposit, acceptedTransactions]);
};
exports.useOpenDepositWhenLowBalance = useOpenDepositWhenLowBalance;
